<template>

    <div>
        <base_aggregator
            @edit_location="edit_location"
            @get_json="get_json"
            @show_menu="show_menu"
            @add_location="add_location"
            @head_action="head_action"
            :provider_id=this.provider_id
            provider_type="pwa"
        >

            <template v-slot:base_location_list="{
                draw_locations,
                listeners,
                has_online,
                has_offline,
                has_sync,
                has_sync_update,
                has_json,
                has_preview,
                has_busy_mode
            }">

                <b-tabs content-class="mt-3">
                    <b-tab :title="__t('Go Direct')" active>
                        <ul class="nav-menu   mb-sm-4 mb-md-0 rounded " v-if="draw_locations.length > 0">
                            <li class="location_block" v-for="item in draw_locations.filter(item => {return item.provider === 'pwa' && item.is_qr_location == false})" >
                                <location-item
                                    :key="'location_' + item.id"
                                    :item="item"
                                    :has-online="has_online"
                                    :has-offline="has_offline"
                                    :has-sync="has_sync"
                                    :has-sync-update="has_sync_update"
                                    :has-json="has_json"
                                    :has-preview="has_preview"
                                    :has-busy-mode="has_busy_mode"
                                    v-on="listeners"
                                >
                                </location-item>
                            </li>
                        </ul>
                    </b-tab>

                    <b-tab :title="__t('Go Direct QR')">
                        <div class="button_add mb-4">
                            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_qr_location">
                                <span class="fal  fa-eject mr-1"></span>
                                {{__t('ADD_QR_LOCATION')}}
                            </button>
                        </div>

                        <div>
                            <ul class="nav-menu   mb-sm-4 mb-md-0 rounded " v-if="draw_locations.length > 0">
                                <li class="location_block" v-for="item in draw_locations.filter(item => {return item.provider === 'pwa' && item.is_qr_location == true})" >
                                    <location-item
                                        :key="'location_' + item.id"
                                        :item="item"
                                        :has-online="has_online"
                                        :has-offline="has_offline"
                                        :has-sync="has_sync"
                                        :has-sync-update="has_sync_update"
                                        :has-json="has_json"
                                        :has-preview="has_preview"
                                        :has-busy-mode="has_busy_mode"
                                        v-on="listeners"
                                    >
                                    </location-item>
                                </li>
                            </ul>
                        </div>
                    </b-tab>

                    <b-tab :title="__t('API')" >
                        <ul class="nav-menu   mb-sm-4 mb-md-0 rounded " v-if="draw_locations.length > 0">
                            <li class="location_block" v-for="item in draw_locations.filter(item => {return item.provider === 'api'})" >
                                <location-item
                                    :key="'api_location_' + item.id"
                                    :item="item"
                                    :has-online="has_online"
                                    :has-offline="has_offline"
                                    :has-sync="has_sync"
                                    :has-sync-update="has_sync_update"
                                    :has-json="has_json"
                                    :has-preview="has_preview"
                                    :has-busy-mode="has_busy_mode"
                                    v-on="listeners"
                                >
                                </location-item>
                            </li>
                        </ul>
                    </b-tab>
                </b-tabs>
            </template>
        </base_aggregator>

        <pwa_location_modal></pwa_location_modal>
        <pwa_qr_location_modal></pwa_qr_location_modal>
        <pwa_settings_modal></pwa_settings_modal>
    </div>
</template>

<script>

import base_aggregator from "../base/base_aggregator";

import {mapGetters} from "vuex";
import pwa_location_modal from "./location/pwa_location_modal";
import pwa_qr_location_modal from "./location/pwa_qr_location_modal.vue";
import pwa_settings_modal from "./settings/pwa_settings_modal";
import LocationItem from "../base/list/list_item.vue";


export default {
    name: "pwa_export",
    components: {LocationItem, pwa_location_modal, base_aggregator,pwa_settings_modal,pwa_qr_location_modal},
    props : {
        provider_id: {
            type: [Number,String],
            required: true,
        },
    },
    created() {
        EventBus.$on('loaded_api',this.load_provider);
        EventBus.$on('reload_provider',this.load_provider);

        if(window.hasOwnProperty('agr_api')) {
            this.load_provider();
        }
    },

    methods: {

        head_action() {
            EventBus.$emit('show_pwa_settings');
        },

        show_menu(location) {
            window.open("/pwa/" + location.id + "/preview");
        },

        get_json(location) {
            agr_api.get('/aggregators/pwa/'+ location.id +'/url').then(({data}) => {
                if (data.status === "operation_success") {
                    let url = data.data;
                    url = url.replace(/\/table(?=\/|$)/, '/menu')
                    window.open(url,'_blank');
                }
            })
            .catch(({response}) => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });

           // window.open("/internal/pwa/restaurants/" + location.id + "/json");
        },

        edit_qr_location(location) {
            EventBus.$emit("location_edit",{
                'org_id' : 0,
                'org_obj' : null,
                'location_id' : location.id,
                'provider_id' : this.provider_id,
                'type' : "pwa_qr"
            });
        },

        add_qr_location(organization) {
            EventBus.$emit("location_edit",{
                'org_id' : 0,
                'org_obj' : null,
                'location_id' : 0,
                'provider_id' : this.provider_id,
                'type' : "pwa_qr"
            });
        },


        edit_location(location) {
            if(location.hasOwnProperty("is_qr_location") && location.is_qr_location) {
                this.edit_qr_location(location);
            }
            else {
                EventBus.$emit("location_edit",{
                    'org_id' : 0,
                    'org_obj' : null,
                    'location_id' : location.id,
                    'provider_id' : this.provider_id,
                });
            }
        },

        add_location(organization) {
            EventBus.$emit("location_edit",{
                'org_id' : organization.id,
                'org_obj' : organization,
                'location_id' : 0,
                'provider_id' : this.provider_id
            });
        },

        load_provider() {
            this.$store.dispatch('aggregator/LOAD_OUT_PROVIDER',this.provider_id);
        }
    },

    computed : {
        ...mapGetters({
            'user'              : "user/getUser",
            'aggregator'        : "aggregator/getAggregator",
            'is_load_complete'  : "aggregator/is_load_complete"
        }),
    }
}
</script>

<style scoped>

</style>
